import { db } from '../firebase';
import { collection, query, getDocs, where } from 'firebase/firestore';
import type { FlexModule } from "@captiva/shared-types";
export type { FlexModule };

// Function to fetch modules from Firestore
export const fetchModulesFromFirestore = async (): Promise<FlexModule[]> => {
  try {
    const modulesQuery = query(collection(db, 'flexModules'), where('isActive', '==', true));
    const querySnapshot = await getDocs(modulesQuery);

    const modules = querySnapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: doc.id,
        name: data.name || '',
        description: data.description || '',
        isActive: data.isActive || false,
        templates: data.templates || [],
        reports: data.reports || [],
        optionsSets: data.optionsSets,
        sampleOptionsSets: data.sampleOptionsSets,
        instructions: data.instructions,
        nextSteps: data.nextSteps,
        version: data.version
      } as FlexModule;
    });

    return modules;
  } catch (error) {
    console.error('Error fetching modules from Firestore:', error);
    throw error;
  }
};